import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/page_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  slug_cont: {
    model_name: 'Page',
    column_type: 'string',
    column_name: 'slug',
  },
  title_cont: {
    model_name: 'Page',
    column_type: 'string',
    column_name: 'title',
  },
}
export const formColumnsConfig = {
  'self': {
    'slug': { required: true, disabledUpdate: true },
    'title': { required: true, disabledUpdate: false },
    'content': { required: true, disabledUpdate: false },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('Page', columns), filterColumnsExtend)
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('Page', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
